unit uCerrarSolicitud;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, WEBLib.DB, WEBLib.CDS, WEBLib.REST,
  Vcl.Controls, Vcl.Grids, WEBLib.DBCtrls, WEBLib.JSON,
  WEBLib.StdCtrls, System.Variants, Variants,
  WEBLib.ExtCtrls, Vcl.Imaging.jpeg,
  WEBLib.ComCtrls, WEBLib.Buttons, Vcl.StdCtrls, Vcl.Graphics,
  Vcl.Imaging.pngimage, WEBLib.Calendar;

type
  TFCerrarSolicitud = class(TForm)
    CSolicitudHdr: TClientConnection;
    TSolicitudHdr: TClientDataSet;
    DsSolicitudHdr: TDataSource;
    CSolicitudDet: TClientConnection;
    TSolicitudDet: TClientDataSet;
    DsSolicitudDet: TDataSource;
    WebPanel2: TPanel;
    WebDBGrid1: TDBGrid;
    WebSpeedButton5: TSpeedButton;
    WebSpeedButton10: TSpeedButton;
    CEntrenaDoc: TClientConnection;
    TEntrenaDoc: TClientDataSet;
    WebHttpRequest1: THttpRequest;
    WebPanel1: TPanel;
    WebDBGrid2: TDBGrid;
    WebPanel3: TPanel;
    WebEdit2: TEdit;
    WebDBNavigator1: TDBNavigator;
    WebSpeedButton6: TSpeedButton;
    WebDateTimePicker1: TDateTimePicker;
    WebLabel1: TLabel;
    WebEdit1: TEdit;
    WebEdit3: TEdit;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    procedure WebSpeedButton10Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure DsSolicitudHdrDataChange(Sender: TObject; Field: TField);
    procedure CSolicitudDetDataReceived(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
  private
    { Private declarations }
    procedure DesactivaTodo;
    procedure ActivaTodo;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

  type
  TProcedureRef = reference to procedure;

var
  FCerrarSolicitud: TFCerrarSolicitud;

implementation

{$R *.dfm}

procedure SleepAsync(Milliseconds: Integer; AProc: TProcedureRef);
begin
  asm
    setTimeout(function() {
    AProc();
     }, Milliseconds);
  end;
end;

procedure TFCerrarSolicitud.DsSolicitudHdrDataChange(Sender: TObject;
  Field: TField);
begin
CSolicitudDet.Command := httpGET;
CSolicitudDet.URI := 'http://207.244.241.82:9000/SolicitudDet?Folio=' +
  TSolicitudHdr.FieldByName('Folio').AsString;
CSolicitudDet.Active := True;
DesactivaTodo;
end;

procedure TFCerrarSolicitud.WebFormCreate(Sender: TObject);
begin
CSolicitudHdr.Command := httpGET;
CSolicitudHdr.URI := 'http://207.244.241.82:9000/SolicitudHdr?Abiertas=True';
CSolicitudHdr.Active := True;
CEntrenaDoc.Command := httpGET;
CEntrenaDoc.URI := 'http://207.244.241.82:9000/EntrenaDoc';
CEntrenaDoc.Active := True;
WebDateTimePicker1.Date:=Now;
end;

procedure TFCerrarSolicitud.WebSpeedButton10Click(Sender: TObject);
begin
FCerrarSolicitud.Hide;
end;

procedure TFCerrarSolicitud.WebSpeedButton5Click(Sender: TObject);
var
  Data: TJSONObject;
begin
TEntrenaDoc.Locate('Codigo', TSolicitudHdr.FieldByName('NoDocumento').AssTring, []);
TSolicitudDet.First;
while not TSolicitudDet.Eof do
  begin
    Data := TJSONObject.Create;
    try
      Data.AddPair('Numero', TSolicitudDet.FieldByName('Numero').AsString);
      Data.AddPair('Nombre', TSolicitudDet.FieldByName('EmpPaterno').AsString +
        TSolicitudDet.FieldByName('EmpMaterno').AsString +
        TSolicitudDet.FieldByName('EmpNombre').AsString);
      Data.AddPair('Documento', TEntrenaDoc.FieldByName('Codigo').AsString);
      Data.AddPair('DocumentoDes', TEntrenaDoc.FieldByName('Descripcion')
        .AsString);
      Data.AddPair('Fecha', FormatDateTime('MM/DD/YYYY',
        WebDateTimePicker1.Date));
      Data.AddPair('Revision', TEntrenaDoc.FieldByName('Revision').AsString);
      Data.AddPair('Puesto', TSolicitudDet.FieldByName('Puesto').AsString);
      Data.AddPair('PuestoDes', '');
      Data.AddPair('Depto', TSolicitudDet.FieldByName('Depto').AsString);
      Data.AddPair('DeptoDes', '');

      if TSolicitudHdr.FieldByName('OnClass').AsString > '' then
      begin
        Data.AddPair('Sala', 'Classroom');
      end;
      if TSolicitudHdr.FieldByName('OnDem').AsString > '' then
      begin
        Data.AddPair('Sala', 'Demostration');
      end;
      if TSolicitudHdr.FieldByName('OnJob').AsString > '' then
      begin
        Data.AddPair('Sala', 'On the job');
      end;
      if TSolicitudHdr.FieldByName('OnVideo').AsString > '' then
      begin
        Data.AddPair('Sala', 'Video');
      end;
      if TSolicitudHdr.FieldByName('OnSemin').AsString > '' then
      begin
        Data.AddPair('Sala', 'Semminars/Courses');
      end;
      if TSolicitudHdr.FieldByName('OnSelf').AsString > '' then
      begin
        Data.AddPair('Sala', 'Self study of company');
      end;
      if TSolicitudHdr.FieldByName('OnOther').AsString > '' then
      begin
        Data.AddPair('Sala', TSolicitudHdr.FieldByName('OnOther').AsString);
      end;
      //Data.AddPair('DuracionH', TEntrenaDoc.FieldByName('DuracionH').AsString);
      //Data.AddPair('DuracionM', TEntrenaDoc.FieldByName('DuracionM').AsString);
      Data.AddPair('Duracion', WebEdit1.Text);
      Data.AddPair('DuracionTotal', WebEdit3.Text);
      Data.AddPair('Entrenador', TSolicitudHdr.FieldByName('Nombre2').AsString);
      Data.AddPair('DocNum', TSolicitudHdr.FieldByName('Nombre2').AsString);
      Data.AddPair('Folio', TSolicitudHdr.FieldByName('Folio').AsString);
      Data.AddPair('Folio2', '');
      Data.AddPair('Externo', 'False');
      WebHttpRequest1.URL := 'http://207.244.241.82:9000/Entrenamientos';
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
      WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
      WebHttpRequest1.Command := httpPOST;
      WebHttpRequest1.PostData := Data.ToJSON;
      WebHttpRequest1.Execute;
    finally
      Data.Free;
    end;
  TSolicitudDet.Next;
  end;
  Data := TJSONObject.Create;
  try
    Data.AddPair('Registro', TSolicitudHdr.FieldByName('Registro').AsString);
    WebHttpRequest1.URL := 'http://207.244.241.82:9000/CerrarSolicitudHdr';
    WebHttpRequest1.Headers.Clear;
    WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
    WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
    WebHttpRequest1.Command := httpPUT;
    WebHttpRequest1.PostData := Data.ToJSON;
    WebHttpRequest1.Execute;
  finally
    Data.Free;
  end;
  DesactivaTodo;
  SleepAsync(300,
    procedure
    begin
      TSolicitudHdr.Refresh;
    end);
end;

procedure TFCerrarSolicitud.WebSpeedButton6Click(Sender: TObject);
begin
TSolicitudHdr.Locate('Folio', WebEdit2.Text, []);
end;

procedure TFCerrarSolicitud.CSolicitudDetDataReceived(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
begin
ActivaTodo;
end;

procedure TFCerrarSolicitud.DesactivaTodo;
begin
WebDBGrid1.Enabled:=False;
WebSpeedButton5.Enabled:=False;
end;

procedure TFCerrarSolicitud.ActivaTodo;
begin
WebDBGrid1.Enabled:=True;
WebSpeedButton5.Enabled:=True;
end;

procedure TFCerrarSolicitud.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel2 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebDBGrid1 := TDBGrid.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  WebDateTimePicker1 := TDateTimePicker.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebSpeedButton10 := TSpeedButton.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebDBGrid2 := TDBGrid.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebDBNavigator1 := TDBNavigator.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  CSolicitudHdr := TClientConnection.Create(Self);
  TSolicitudHdr := TClientDataSet.Create(Self);
  DsSolicitudHdr := TDataSource.Create(Self);
  CSolicitudDet := TClientConnection.Create(Self);
  TSolicitudDet := TClientDataSet.Create(Self);
  DsSolicitudDet := TDataSource.Create(Self);
  CEntrenaDoc := TClientConnection.Create(Self);
  TEntrenaDoc := TClientDataSet.Create(Self);
  WebHttpRequest1 := THttpRequest.Create(Self);

  WebPanel2.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebDBGrid1.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  WebDateTimePicker1.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebSpeedButton10.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebDBGrid2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebDBNavigator1.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  CSolicitudHdr.BeforeLoadDFMValues;
  TSolicitudHdr.BeforeLoadDFMValues;
  DsSolicitudHdr.BeforeLoadDFMValues;
  CSolicitudDet.BeforeLoadDFMValues;
  TSolicitudDet.BeforeLoadDFMValues;
  DsSolicitudDet.BeforeLoadDFMValues;
  CEntrenaDoc.BeforeLoadDFMValues;
  TEntrenaDoc.BeforeLoadDFMValues;
  WebHttpRequest1.BeforeLoadDFMValues;
  try
    Name := 'FCerrarSolicitud';
    Width := 1148;
    Height := 580;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 16;
    WebPanel2.Top := 88;
    WebPanel2.Width := 831;
    WebPanel2.Height := 457;
    WebPanel2.HeightPercent := 100.000000000000000000;
    WebPanel2.WidthPercent := 100.000000000000000000;
    WebPanel2.BorderColor := clBlack;
    WebPanel2.BorderStyle := bsSingle;
    WebPanel2.ChildOrder := 4;
    WebPanel2.Color := clInfoBk;
    WebLabel1.SetParentComponent(WebPanel2);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 16;
    WebLabel1.Top := 397;
    WebLabel1.Width := 92;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'Fecha de finalizado';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel2);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 168;
    WebLabel2.Top := 397;
    WebLabel2.Width := 46;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'Duraci'#243'n:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel2);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 312;
    WebLabel3.Top := 397;
    WebLabel3.Width := 71;
    WebLabel3.Height := 13;
    WebLabel3.Caption := 'Duraci'#243'n total:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebDBGrid1.SetParentComponent(WebPanel2);
    WebDBGrid1.Name := 'WebDBGrid1';
    WebDBGrid1.Left := 16;
    WebDBGrid1.Top := 16;
    WebDBGrid1.Width := 801;
    WebDBGrid1.Height := 369;
    WebDBGrid1.Columns.Clear;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Folio';
      Title := 'Folio';
      Width := 100;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Nombre';
      Title := 'Solicitante';
      Width := 100;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Nombre2';
      Title := 'Capacitador/Entrenador';
      Width := 100;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'NoDocumento';
      Title := 'Documento';
      Width := 100;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'DocumentoNombre';
      Title := 'Descripci'#243'n';
      Width := 350;
    end;
    WebDBGrid1.DataSource := DsSolicitudHdr;
    WebDBGrid1.FixedCols := 1;
    WebDBGrid1.TabOrder := 0;
    WebDBGrid1.HeightPercent := 100.000000000000000000;
    WebDBGrid1.WidthPercent := 100.000000000000000000;
    WebDBGrid1.ColWidths[0] := 24;
    WebDBGrid1.ColWidths[1] := 100;
    WebDBGrid1.ColWidths[2] := 100;
    WebDBGrid1.ColWidths[3] := 100;
    WebDBGrid1.ColWidths[4] := 100;
    WebDBGrid1.ColWidths[5] := 350;
    WebSpeedButton5.SetParentComponent(WebPanel2);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 680;
    WebSpeedButton5.Top := 405;
    WebSpeedButton5.Width := 137;
    WebSpeedButton5.Height := 33;
    WebSpeedButton5.Caption := 'Finalizar solicitud';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.Glyph.LoadFromFile('uCerrarSolicitud.WebPanel2.WebSpeedButton5.Glyph.png');
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    WebDateTimePicker1.SetParentComponent(WebPanel2);
    WebDateTimePicker1.Name := 'WebDateTimePicker1';
    WebDateTimePicker1.Left := 16;
    WebDateTimePicker1.Top := 416;
    WebDateTimePicker1.Width := 129;
    WebDateTimePicker1.Height := 22;
    WebDateTimePicker1.HeightPercent := 100.000000000000000000;
    WebDateTimePicker1.WidthPercent := 100.000000000000000000;
    WebDateTimePicker1.BorderStyle := bsSingle;
    WebDateTimePicker1.ChildOrder := 2;
    WebDateTimePicker1.Color := clWhite;
    WebDateTimePicker1.Date := 46049.568205752320000000;
    WebDateTimePicker1.Role := '';
    WebDateTimePicker1.Text := '';
    WebEdit1.SetParentComponent(WebPanel2);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 168;
    WebEdit1.Top := 416;
    WebEdit1.Width := 121;
    WebEdit1.Height := 22;
    WebEdit1.ChildOrder := 4;
    WebEdit1.HeightPercent := 100.000000000000000000;
    WebEdit1.WidthPercent := 100.000000000000000000;
    WebEdit3.SetParentComponent(WebPanel2);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 312;
    WebEdit3.Top := 416;
    WebEdit3.Width := 121;
    WebEdit3.Height := 22;
    WebEdit3.ChildOrder := 4;
    WebEdit3.HeightPercent := 100.000000000000000000;
    WebEdit3.WidthPercent := 100.000000000000000000;
    WebSpeedButton10.SetParentComponent(Self);
    WebSpeedButton10.Name := 'WebSpeedButton10';
    WebSpeedButton10.Left := 1045;
    WebSpeedButton10.Top := 24;
    WebSpeedButton10.Width := 81;
    WebSpeedButton10.Height := 44;
    WebSpeedButton10.Caption := 'Salir';
    WebSpeedButton10.Color := clNone;
    WebSpeedButton10.Glyph.LoadFromFile('uCerrarSolicitud.WebSpeedButton10.Glyph.png');
    WebSpeedButton10.HeightPercent := 100.000000000000000000;
    WebSpeedButton10.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton10, Self, 'OnClick', 'WebSpeedButton10Click');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 853;
    WebPanel1.Top := 88;
    WebPanel1.Width := 274;
    WebPanel1.Height := 457;
    WebPanel1.HeightPercent := 100.000000000000000000;
    WebPanel1.WidthPercent := 100.000000000000000000;
    WebPanel1.BorderColor := clBlack;
    WebPanel1.BorderStyle := bsSingle;
    WebPanel1.ChildOrder := 4;
    WebPanel1.Color := clInfoBk;
    WebDBGrid2.SetParentComponent(WebPanel1);
    WebDBGrid2.Name := 'WebDBGrid2';
    WebDBGrid2.Left := 16;
    WebDBGrid2.Top := 16;
    WebDBGrid2.Width := 241;
    WebDBGrid2.Height := 369;
    WebDBGrid2.Columns.Clear;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'Numero';
      Title := 'Numero';
      Width := 100;
    end;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'Puesto';
      Title := 'Puesto';
      Width := 100;
    end;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'Folio';
    end;
    WebDBGrid2.DataSource := DsSolicitudDet;
    WebDBGrid2.FixedCols := 1;
    WebDBGrid2.TabOrder := 0;
    WebDBGrid2.HeightPercent := 100.000000000000000000;
    WebDBGrid2.WidthPercent := 100.000000000000000000;
    WebDBGrid2.ColWidths[0] := 24;
    WebDBGrid2.ColWidths[1] := 100;
    WebDBGrid2.ColWidths[2] := 100;
    WebDBGrid2.ColWidths[3] := 64;
    WebPanel3.SetParentComponent(Self);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 16;
    WebPanel3.Top := 24;
    WebPanel3.Width := 497;
    WebPanel3.Height := 58;
    WebPanel3.HeightPercent := 100.000000000000000000;
    WebPanel3.WidthPercent := 100.000000000000000000;
    WebPanel3.BorderColor := clBlack;
    WebPanel3.BorderStyle := bsSingle;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clInfoBk;
    WebEdit2.SetParentComponent(WebPanel3);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 14;
    WebEdit2.Top := 19;
    WebEdit2.Width := 179;
    WebEdit2.Height := 22;
    WebEdit2.ChildOrder := 2;
    WebEdit2.HeightPercent := 100.000000000000000000;
    WebEdit2.WidthPercent := 100.000000000000000000;
    WebDBNavigator1.SetParentComponent(WebPanel3);
    WebDBNavigator1.Name := 'WebDBNavigator1';
    WebDBNavigator1.Left := 239;
    WebDBNavigator1.Top := 19;
    WebDBNavigator1.Width := 130;
    WebDBNavigator1.Height := 25;
    WebDBNavigator1.HeightPercent := 100.000000000000000000;
    WebDBNavigator1.WidthPercent := 100.000000000000000000;
    WebDBNavigator1.DataSource := DsSolicitudHdr;
    WebDBNavigator1.Hints.BeginUpdate;
    try
      WebDBNavigator1.Hints.Clear;
      WebDBNavigator1.Hints.Add('First');
      WebDBNavigator1.Hints.Add('Prior');
      WebDBNavigator1.Hints.Add('Next');
      WebDBNavigator1.Hints.Add('Last');
      WebDBNavigator1.Hints.Add('Edit');
      WebDBNavigator1.Hints.Add('Post');
      WebDBNavigator1.Hints.Add('Insert');
      WebDBNavigator1.Hints.Add('Delete');
      WebDBNavigator1.Hints.Add('Cancel');
    finally
      WebDBNavigator1.Hints.EndUpdate;
    end;
    WebDBNavigator1.VisibleButtons := [nbFirst,nbPrior,nbNext,nbLast];
    WebSpeedButton6.SetParentComponent(WebPanel3);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 199;
    WebSpeedButton6.Top := 19;
    WebSpeedButton6.Width := 24;
    WebSpeedButton6.Height := 24;
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.Glyph.LoadFromFile('uCerrarSolicitud.WebPanel3.WebSpeedButton6.Glyph.png');
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    CSolicitudHdr.SetParentComponent(Self);
    CSolicitudHdr.Name := 'CSolicitudHdr';
    CSolicitudHdr.Active := False;
    CSolicitudHdr.Left := 436;
    CSolicitudHdr.Top := 32;
    TSolicitudHdr.SetParentComponent(Self);
    TSolicitudHdr.Name := 'TSolicitudHdr';
    TSolicitudHdr.Connection := CSolicitudHdr;
    TSolicitudHdr.Left := 500;
    TSolicitudHdr.Top := 32;
    DsSolicitudHdr.SetParentComponent(Self);
    DsSolicitudHdr.Name := 'DsSolicitudHdr';
    DsSolicitudHdr.DataSet := TSolicitudHdr;
    SetEvent(DsSolicitudHdr, Self, 'OnDataChange', 'DsSolicitudHdrDataChange');
    DsSolicitudHdr.Left := 564;
    DsSolicitudHdr.Top := 32;
    CSolicitudDet.SetParentComponent(Self);
    CSolicitudDet.Name := 'CSolicitudDet';
    CSolicitudDet.Active := False;
    SetEvent(CSolicitudDet, Self, 'OnDataReceived', 'CSolicitudDetDataReceived');
    CSolicitudDet.Left := 436;
    CSolicitudDet.Top := 80;
    TSolicitudDet.SetParentComponent(Self);
    TSolicitudDet.Name := 'TSolicitudDet';
    TSolicitudDet.Connection := CSolicitudDet;
    TSolicitudDet.Left := 500;
    TSolicitudDet.Top := 80;
    DsSolicitudDet.SetParentComponent(Self);
    DsSolicitudDet.Name := 'DsSolicitudDet';
    DsSolicitudDet.DataSet := TSolicitudDet;
    DsSolicitudDet.Left := 564;
    DsSolicitudDet.Top := 80;
    CEntrenaDoc.SetParentComponent(Self);
    CEntrenaDoc.Name := 'CEntrenaDoc';
    CEntrenaDoc.Active := False;
    CEntrenaDoc.Left := 432;
    CEntrenaDoc.Top := 128;
    TEntrenaDoc.SetParentComponent(Self);
    TEntrenaDoc.Name := 'TEntrenaDoc';
    TEntrenaDoc.Connection := CEntrenaDoc;
    TEntrenaDoc.Left := 504;
    TEntrenaDoc.Top := 128;
    WebHttpRequest1.SetParentComponent(Self);
    WebHttpRequest1.Name := 'WebHttpRequest1';
    WebHttpRequest1.Headers.BeginUpdate;
    try
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.Add('Cache-Control=no-cache, no-store, must-revalidate');
    finally
      WebHttpRequest1.Headers.EndUpdate;
    end;
    WebHttpRequest1.Left := 336;
    WebHttpRequest1.Top := 56;
  finally
    WebPanel2.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebDBGrid1.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    WebDateTimePicker1.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebSpeedButton10.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebDBGrid2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebDBNavigator1.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    CSolicitudHdr.AfterLoadDFMValues;
    TSolicitudHdr.AfterLoadDFMValues;
    DsSolicitudHdr.AfterLoadDFMValues;
    CSolicitudDet.AfterLoadDFMValues;
    TSolicitudDet.AfterLoadDFMValues;
    DsSolicitudDet.AfterLoadDFMValues;
    CEntrenaDoc.AfterLoadDFMValues;
    TEntrenaDoc.AfterLoadDFMValues;
    WebHttpRequest1.AfterLoadDFMValues;
  end;
end;

end.
